<ng-container *transloco="let t">
  <div class="leishmania-finding" [formGroup]="form">
    <div class="field">
      <label class="label">{{ t('leishmania.title') }}</label>
      <mat-form-field appearance="outline" class="w-full">
        <textarea matInput formControlName="leishmaniaTest" rows="4"></textarea>
      </mat-form-field>
    </div>

    <div class="field">
      <label class="label">{{ t('leishmania.note') }}</label>
      <mat-form-field appearance="outline" class="w-full">
        <textarea
          matInput
          formControlName="note"
          rows="4"
          placeholder="{{ t('Additional notes') }}"
        ></textarea>
      </mat-form-field>
    </div>

    <mat-form-field appearance="outline" class="w-full mb-3">
      <mat-label>{{ t('veterinarianName') }}</mat-label>
      <input matInput formControlName="veterinarianName" />
      <mat-error>{{ t('This field is required') }}</mat-error>
    </mat-form-field>
  </div>
</ng-container>
